// Shared tabs with an optional count-chip per tab.
// Bron: prototype-mui/App.jsx SectionTabs.
import { Box, Chip, Tab, Tabs } from '@mui/material';

const SectionTabs = ({ tabs, value, onChange, sx }) => (
  <Tabs
    value={value}
    onChange={onChange}
    sx={{ minHeight: 32, mb: 1.5, ...sx }}
  >
    {tabs.map((tab) => (
      <Tab
        key={tab.label}
        label={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            {tab.label}
            {typeof tab.count === 'number' ? (
              <Chip label={tab.count} size="small" />
            ) : null}
          </Box>
        }
        sx={{ minHeight: 32, py: 0 }}
      />
    ))}
  </Tabs>
);

export default SectionTabs;
